import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,{attrs:{"tile":"","loading":_vm.loading}},[_c(VCardText,[_c(VRow,{attrs:{"dense":""}},_vm._l((_vm.items),function(next,i){return _c(VCol,{key:i,staticClass:"text-h6 text-center"},[_c('div',[_c('p',{staticClass:"font-weight-bold black--text"},[_vm._v(" "+_vm._s(next.nombre)+" "+_vm._s((next.id == 1) ? '+ BASE' : '')+" ")]),_c('p',[_vm._v("$ "+_vm._s(_vm.ShowImporte(next)))])])])}),1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }